// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Ti-z","carouselContainer":"Ui-z","carouselContent":"Vi-z"};